import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {SelectableLab} from '../carrier/selectable-lab';
import {ActionComponentType} from '../constants/ActionComponentType';
import {ButtonType} from '../constants/ButtonType';
import {PlateScanType, PopUpScanType} from '../constants/PlateScanType';
import {ExtractionProtocolComponentName, ProtocolComponentMapping, ProtocolComponentName} from '../constants/ProtocolComponentMapping';
import {ArrayStatus, StepStatus} from '../constants/Status';
import {WidgetType} from '../constants/WidgetType';
import {GenericMultiPlateUpdateDTO} from '../dto/genericMultiPlateUpdateDTO';
import {PlateScanDTO} from '../dto/plateScanDTO';
import {Machine} from '../masterdata/models/machine';
import {Project} from '../masterdata/models/project';
import {ProjectWorkflow} from '../masterdata/models/projectWorkflow';
import {MessagesNewService} from '../messages-new/messages.service';
import {Plate} from '../models-new/plate';
import {ProcessStep} from '../models-new/processStep';
import {PlateProcessingService} from '../plate-processing/plate-processing.service';
import {ActionComponent} from '../protocol-configuration/dto/ActionComponent';
import {PopUpComponent} from '../protocol-configuration/dto/PopUpComponent';
import {Protocol, ProtocolType} from '../protocol-configuration/dto/Protocol';
import {ProtocolComponent} from '../protocol-configuration/dto/ProtocolComponent';
import {Widget} from '../protocol-configuration/dto/Widget';
import {OpenDialogDTO} from './open-dialog-dto';
import {BatchTypes} from '../models/process-step';
import {CreateBatchDTO} from '../dto/createBatchDTO';
import {Batch} from "../models-new/batch";
import {ConfirmationService} from "primeng/api";
import {RemoveSelectedPlateFromBatch} from "../dto/remove-selected-plate-from-batch";
import {StorageService} from '../storage-new/storage-new.service';
import {Action} from '../models-new/action';
import {Screen, validateBatchEligibility, validateProtocolForPlate} from "../utils/validation-util";
import {ConfigurationService} from "../protocol-configuration/configuration.service";

const PLATE_NOT_ELIGIBLE = "Plate not eligible!";
@Component({
  selector: 'app-multiplate-update',
  templateUrl: './multiplate-update.component.html',
  styleUrls: ['./multiplate-update.component.css']
})
export class MultiplateUpdateComponent {
	@Input() selectedProtocol: Protocol;
	@Input() machineBarcodeMap: Map<string, Machine>;
	@Input() selectedPlateProcessStepMap: Map<string, ProcessStep>;
	@Input() openDialogDTO: OpenDialogDTO;
	@Input() projectMap: Map<string, Project> = new Map();
	@Input() workflowMap: Map<string, ProjectWorkflow> = new Map();
	@Input() selectedProjectWorkflow: ProjectWorkflow;
	@Input() selectedProject: Project;
    @Input() screen:Screen;

	@Output() platesUpdatedEmitter = new EventEmitter<any>();
	@Output() dialogHeaderEmitter = new EventEmitter<any>();
	@Output() closeDialogEmitter = new EventEmitter<any>();
	@Output() updatedPlateCacheEmitter = new EventEmitter<Plate[]>();

	readonly widgetTypesWithInput: Array<string> = [WidgetType.CHEMICAL_LOT, WidgetType.EQUIPMENT];
	readonly popScanDivClassMapping: Map<number, string> = new Map([[1, "col-6"], [2, "col-11"], [3, "col-11"], [4, "col-11"]]);
	readonly popScanInputClassMapping: Map<number, string> = new Map([[1, "col-12"], [2, "col-6"], [3, "col-4"], [4, "col-3"]]);
	readonly ARRAY_STEP_LIST_FIELD_NAME = "protocolArrayStepList";

	blocked = false;
	selectedLab: SelectableLab;
	puid: string;
	dialogHeader = "";
	popUpComponent: PopUpComponent = new PopUpComponent();
	popUpProtocolComponentName!: string;
	popUpProtocolComponentIndex = 0;
	popUpAction!: ActionComponent;
	popUpActionIndex = -1;
	popUpUpdateType!: string;
	dialogSubmitButtonClass = "";
	popUpScanInputValues: Array<string> = [];
	popUpScanInputSourcePlateID = "";
	plateScanValues: Array<Array<string>> = [];
	plateSourcePlateIDValues: Array<string> = [];
	batchView = false;
	batchIDValid = false;
	batchID: string;
	batchPlates: Plate[] = [];

	popUpWidgetInputValues: any = {};
	popUpWidgetCheckboxValues: any = {};
	plateWidgetValues: Map<string, Array<string>> = new Map();
	underFilledPlates: Set<string> = new Set();
    selectedBatch:Batch;
    scannedBatches:Map<string,Set<string>> = new Map();
    plateBatchMap:Map<string,string> = new Map();
    fetchedBatches:Map<string,Set<string>> = new Map();
    lastUpdatedPlateMap:Map<string,string> = new Map();
	storagePlateIds: Array<string> = [];
	updatedPlatesCache: Array<Plate> = [];
	disableScanInput = false;

	private readonly PLATE_NOT_AVAILABLE = "Plate ID not available";
	readonly RESTORATION_FAILED_SUMMARY = "Restoration failed";

	readonly COMPONENT_WITH_NO_PROCESS_STEPS: Set<string> = new Set([
		ExtractionProtocolComponentName.BATCHING,ExtractionProtocolComponentName.SAMPLE_PLACEMENT,
		ProtocolComponentName.PRECELL]);
    readonly FIELD_EMPTY = "Field empty!";

	constructor(
		private readonly plateProcessingService: PlateProcessingService,
		private readonly messagesService: MessagesNewService,
		private readonly confirmationService: ConfirmationService,
		private readonly storageService: StorageService,
        private readonly configurationService:ConfigurationService
	) {
	}

	ngOnInit(){
		this.selectedLab = JSON.parse(localStorage.getItem('lab') || '{"lab":""}');
		this.puid = localStorage.getItem('PUID') || "PUID";
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes["openDialogDTO"]) {
			this.setUpComponentForUpdates();
		}
	}

	 setUpComponentForUpdates() {
		if(!this.openDialogDTO){
			this.clearAllPopUpValues();
			return;
		}

		if(this.openDialogDTO.qcFail){
			return;
		}

		const protocolComponent: ProtocolComponent = this.selectedProtocol[this.openDialogDTO.stepMapName][this.openDialogDTO.protocolStepName];
		this.popUpProtocolComponentName = this.openDialogDTO.protocolStepName;
		this.popUpProtocolComponentIndex = this.selectedProtocol[this.openDialogDTO.stepListName].indexOf(this.popUpProtocolComponentName);
		this.popUpUpdateType = this.openDialogDTO.buttonType;

		if (ButtonType.START === this.openDialogDTO.buttonType) {
			this.popUpAction = protocolComponent.start;
		} else if (ButtonType.END === this.openDialogDTO.buttonType) {
			this.popUpAction = protocolComponent.end;
		}else {
			this.popUpAction = protocolComponent.actionMap[this.openDialogDTO.actionName]
			this.popUpActionIndex = this.openDialogDTO.actionIndex;
		}

		this.dialogHeader = this.popUpAction.name;
		this.dialogHeaderEmitter.emit(this.dialogHeader);
		this.popUpComponent = this.popUpAction.popUp;
		if(this.popUpComponent.plateBatching && !this.batchView){
			this.getBatchID();
		}
        if(this.popUpComponent.plateUnbatching){
            this.batchView = !this.batchView;
            this.plateScanValues = [];
            this.batchID = null;
        }
		else{
			this.plateScanValues = [];
			this.plateSourcePlateIDValues = [];
			this.batchID = null;
			this.batchView = false;
			this.batchPlates = [];
		}
		this.popUpScanInputValues = new Array(this.popUpComponent.scans.length);
		this.popUpComponent.widgets.forEach(widget => {
			if (this.widgetTypesWithInput.includes(widget.type)) {
				this.popUpWidgetInputValues[widget.id] = "";
				this.plateWidgetValues.set(widget.id, []);
			}
			if (WidgetType.CHECKBOX === widget.type) {
				this.popUpWidgetCheckboxValues[widget.id] = false;
			}
		})
		this.dialogSubmitButtonClass = this.openDialogDTO.buttonClass;
		setTimeout(() => {
			this.findAndHighlightElement("popUpDialog-scan-0");
            this.loadAnalysisBatch();
		}, 300)
	}

    loadAnalysisBatch(): void {
        if (!this.openDialogDTO.analysisBatchID) {
            return;
        }
        if (this.popUpComponent.plateUnbatching && this.popUpComponent.popUpTitle === ProtocolComponentMapping.getTitle("ANALYSIS", "END")) {
            this.batchID = this.openDialogDTO.analysisBatchID;
            this.validateBatchID();
        } else {
            this.fetchAndCheckIfPlateIsEligible(0, "", this.openDialogDTO.analysisBatchID);
        }
    }

	getBatchID() {
		const prefix = 'P' + new Date().toISOString().slice(0, 10).replace(/-/g, '');
		this.blocked = true;
		this.plateProcessingService.getBatchId(this.selectedLab.lab._id, prefix, BatchTypes.PLATE).subscribe({
			next: result => {
				this.blocked = false;
				this.plateScanValues = [];
				this.plateSourcePlateIDValues = [];
				this.batchPlates = [];
				this.batchID = result.data;
				this.batchView = true;
				this.batchIDValid = true;
			},
			error: error => {
				this.blocked = false;
				this.messagesService.addErrorMessage({
					severity:'error', summary: 'Error occured while getting available batch id',
					detail: error.error.bbApiError.message
				})
			}
		})
	}

	validateBatchID() {
		const batchID = this.batchID.trim();
		if (!batchID) {
			this.messagesService.addWarningMessage({
				severity: 'warn', summary: this.FIELD_EMPTY,
				detail: "Please give a valid Batch ID"
			});
            this.plateScanValues = [];
            this.selectedBatch = undefined;
			return;
		}
		this.blocked = true;
		this.plateProcessingService.getBatch(this.selectedLab.lab._id, batchID).subscribe({
			next: (result) => {
				this.blocked = false;
                const valid = this.validateBatchBasedOnConfiguration(result);
				if(valid){
                    this.selectedBatch = result;
					this.messagesService.addSuccessMessage({
						severity: 'success', summary: "Batch ID Valid"
					});
				}else{
					this.messagesService.addErrorMessage({
						severity:'error', summary: 'Batch ID invalid',
						detail: 'Please scan a different batch'
					});
				}

			},
			error: error => {
				this.blocked = false;
				this.messagesService.addErrorMessage({
					severity:'error', summary: 'Error while validating Batch ID',
					detail: error.error.bbApiError.message
				})
			}
		})
	}

    validateBatchBasedOnConfiguration(batch:Batch): boolean {
        if(this.popUpComponent.plateBatching && this.batchView){
            this.batchIDValid = !batch || (batch && batch.plates.length === 0);
            return this.batchIDValid;
        }
        if(this.popUpComponent.plateUnbatching && this.batchView){
            this.batchIDValid = (batch) && batch.plates.length !== 0;
            if(this.batchIDValid){
                this.pushPlatesToMultiUpdateDTO(batch);
            }
            return this.batchIDValid;
        }
        return batch.plates.length !== 0;
    }

    pushPlatesToMultiUpdateDTO(batch:Batch){
        // This will be the first scan, since only 1 scan type is allowed
        // from the configuration in case of batching/unbatching
        const scanIndex = 0;
        this.plateScanValues = [];
        this.plateProcessingService.getPlatesBasedOnBatch(this.selectedLab.lab._id,batch.batchID).subscribe({
            next: (plates) => {
                plates.forEach(plate => {
                    this.popUpScanInputValues = [plate.lastUpdatedPlateID];
                    this.popUpScanInputSourcePlateID = plate.plateID;
                    this.highlightNextScanInPopUpDialog(scanIndex);
                });
            },
            error: (_error) => {
                this.messagesService.addErrorMessage({
                    severity:'error',summary:'Unable to fetch batch level Information',
                    detail:`Unable to fetch plates for the batch ${batch.batchID}.Please contact BB support`
                });
            }
        });
        this.popUpScanInputValues = [];
        this.popUpScanInputSourcePlateID = "";
    }

	getClassForScanDivs() {
		return this.popScanDivClassMapping.get(this.popUpComponent.scans.length);
	}

	getClassForScanInputs() {
		return this.popScanInputClassMapping.get(this.popUpComponent.scans.length);
	}

	addChemicalLot(widgetId: string) {
		const lotValue = this.popUpWidgetInputValues[widgetId].trim();
		if (lotValue === "") {
			return;
		}

		this.popUpWidgetInputValues[widgetId] = "";
		this.plateWidgetValues.get(widgetId)?.unshift(lotValue);
	}

	removeChemicalLot(widgetId: string, index: number) {
		this.plateWidgetValues.get(widgetId)?.splice(index, 1);
	}

	disablePopupWidget(widgetIndex: number): boolean {
		if (widgetIndex === 0) {
			return !this.checkPlateScanValues();
		}

		const previousWidget = this.findPreviousNonTextWidget(widgetIndex);

		if (!previousWidget) {
			return !this.checkPlateScanValues();
		}

		return this.disableBasedOnPrevious(previousWidget);
	}

	private checkPlateScanValues(): boolean {
		return Array.isArray(this.plateScanValues) && this.plateScanValues.length > 0;
	}

	findPreviousNonTextWidget(widgetIndex: number) {
		let previousWidget;
		for (let i = widgetIndex - 1; i >= 0; i--) {
			const widget = this.popUpComponent.widgets[i];
			if (widget.type !== WidgetType.TEXT) {
				previousWidget = widget
				break;
			}
		}
		return previousWidget;
	}

	private disableBasedOnPrevious(previousWidget: Widget): boolean {
		switch (previousWidget.type) {
			case WidgetType.CHECKBOX:
				return !this.popUpWidgetCheckboxValues[previousWidget.id];
			case WidgetType.EQUIPMENT:
				return !this.popUpWidgetInputValues[previousWidget.id]?.trim();
			case WidgetType.CHEMICAL_LOT:
				return !this.plateWidgetValues.get(previousWidget.id)?.length;
			default:
				return false;
		}
	}

	findAndHighlightElement(elementId: string) {
		const element = document.getElementById(elementId);
		if (element) {
			element.focus();
		}
	}

    areSetEqual(set1:Set<any>, set2:Set<any>): boolean{
        if(set1.size !== set2.size) {
            return false;
        }

        return [...set1].every(item => set2.has(item));
    }

	disableSubmitPopUpButton() {
		if (this.plateScanValues.length === 0) {
			return true;
		}
		if(this.popUpComponent.plateBatching && !this.batchIDValid){
			return true;
		}
        if(this.validateBatchingAndUnbatching()) {
            for(const [batch,scannedPlates] of this.scannedBatches){
                const batchedPlates = this.getBatchedPlates(batch);
                if(!this.areSetEqual(batchedPlates,scannedPlates)){
                    return true;
                }
            }
        }

		let disable = false;
		for (let i = 0; i < this.popUpComponent.widgetCount; i++) {
			if (this.widgetTypesWithInput.includes(this.popUpComponent.widgets[i].type)) {
				disable = this.plateWidgetValues.get(this.popUpComponent.widgets[i].id)?.length === 0;
			}
			if (WidgetType.CHECKBOX === this.popUpComponent.widgets[i].type) {
				disable = !this.popUpWidgetCheckboxValues[this.popUpComponent.widgets[i].id];
			}

			if (disable) {
				return disable;
			}
		}

		return disable;
	}

    private getBatchedPlates(batch: string) {
        return this.fetchedBatches.get(batch) ?? new Set<string>();
    }

    private validateBatchingAndUnbatching() {
        return this.scannedBatches.size !== 0;
    }

    getIndex(actionList: string[]): number {
		if (this.popUpUpdateType === ButtonType.START) {
			return 0;
		} else if (this.popUpUpdateType === ButtonType.END) {
			return actionList.length + 1;
		} else {
			return actionList.indexOf(this.popUpAction.name) + 1;
		}
	}

	clearAllPopUpValues(trackBatchDetails = false) {
		this.popUpScanInputValues = [];
		this.popUpScanInputSourcePlateID = "";
		this.plateScanValues = [];
		this.plateSourcePlateIDValues = [];
		this.popUpComponent = new PopUpComponent();

		this.popUpWidgetInputValues = {};
		this.popUpWidgetCheckboxValues = {};
		this.plateWidgetValues = new Map();

		this.dialogHeader = "";
		this.popUpProtocolComponentName = "";
		this.popUpProtocolComponentIndex = -1;
		this.popUpAction = new ActionComponent();
		this.popUpActionIndex = -1;
		this.popUpUpdateType = "";
		this.dialogSubmitButtonClass = "";
        this.batchID = "";
		this.storagePlateIds = [];
		if (!trackBatchDetails) {
			this.scannedBatches = new Map();
			this.fetchedBatches = new Map();
		}
		this.updatedPlatesCache = [];
	}

    resetBatchRelatedInfo() {
        this.scannedBatches = new Map();
        this.fetchedBatches = new Map();
        this.plateBatchMap = new Map();
        this.lastUpdatedPlateMap = new Map();
    }

	removeMultiplePlatesFromStorage() {
		const body = {
			"labid": this.selectedLab.lab._id,
			"plateids": this.storagePlateIds
		}
		this.blocked = true
		this.storageService.removeMultiplePlatesFromStorage(body).subscribe({
			next: (result) => {
				this.blocked = false
				this.messagesService.addSuccessMessage({
					severity: "success", summary: "Restoration success",
					detail: result
				})
			},
			error: (error: any) => {
				this.blocked = false
				this.messagesService.addErrorMessage({
					severity: "error", summary: this.RESTORATION_FAILED_SUMMARY,
					detail: error
				})
			}
		})
	}

    updateMultiplePlates() {
		const genericMultiPlateUpdateDTO: GenericMultiPlateUpdateDTO = this.prepareDataForGenericMultiPlateUpdate();
		this.plateProcessingService.genericMultiPlateUpdate(genericMultiPlateUpdateDTO).subscribe({
			next: (result) => {
				this.blocked = false;
				this.messagesService.addSuccessMessage({
					severity: 'success', summary: 'Plates updated successfully.',
					detail: result.data
				});

				if(this.storagePlateIds.length >= 1){
					this.removeMultiplePlatesFromStorage();
				}

				const actionList = this.openDialogDTO.requiredActions;
				const actionMap = this.selectedProtocol[this.openDialogDTO.stepMapName][this.popUpProtocolComponentName].actionMap;
				const triggerNextAction = this.popUpAction?.popUp?.triggerNextAction || false;
				if (!triggerNextAction) {
					this.platesUpdatedEmitter.emit(true);
					this.closeDialogEmitter.emit(true);
					this.updatedPlateCacheEmitter.emit(this.updatedPlatesCache);
					this.clearAllPopUpValues();
                    this.resetBatchRelatedInfo();
					return
				}
				const index = this.getIndex(actionList);
				const openDialogDTO: OpenDialogDTO = new OpenDialogDTO();
                openDialogDTO.requiredActions = this.openDialogDTO.requiredActions;
				if (index < actionList.length) {
					openDialogDTO.buttonType = ButtonType.ACTION;
					openDialogDTO.actionName = actionMap[actionList[index]].name;
					openDialogDTO.actionIndex = index;
					openDialogDTO.actionType = actionMap[actionList[index]].actionType;
					openDialogDTO.buttonClass = 'action-button';
					openDialogDTO.scans = actionMap[actionList[index]].hasPopUp ? actionMap[actionList[index]].popUp.scans : []

				} else if (index >= actionList.length) {
					openDialogDTO.buttonType = ButtonType.END;
					openDialogDTO.actionName = "";
					openDialogDTO.actionIndex = 0;
					openDialogDTO.actionType = ActionComponentType.NORMAL;
					openDialogDTO.buttonClass = 'complete-button';
					openDialogDTO.end = this.selectedProtocol[this.openDialogDTO.stepMapName][this.popUpProtocolComponentName].end;
					openDialogDTO.scans = this.selectedProtocol[this.openDialogDTO.stepMapName][this.popUpProtocolComponentName].end.hasPopUp ? this.selectedProtocol[this.openDialogDTO.stepMapName][this.popUpProtocolComponentName].end.popUp.scans : []
				}
				openDialogDTO.protocolStepName = this.popUpProtocolComponentName;
				openDialogDTO.protocolStepIndex = this.popUpProtocolComponentIndex;
				openDialogDTO.stepListName = this.openDialogDTO.stepListName;
				openDialogDTO.stepMapName = this.openDialogDTO.stepMapName;
				openDialogDTO.plateScanValue = this.getPlateScanForNextPopUp(actionMap, actionList, index, openDialogDTO, this.plateScanValues, openDialogDTO.scans);
				openDialogDTO.plateSourcePlateIDValues = this.plateSourcePlateIDValues;

				this.platesUpdatedEmitter.emit(this.popUpAction.name);
				this.updatedPlateCacheEmitter.emit(this.updatedPlatesCache);
				this.clearAllPopUpValues(triggerNextAction && this.scannedBatches.size > 0);
				setTimeout(() => {
					this.checkForPopUp(actionMap, actionList, index, openDialogDTO);
				}, 300)
			},
			error: (error) => {
				this.blocked = false;
				this.messagesService.addErrorMessage({
					severity: "error", summary: "Error while updating plates.",
					detail: error.error.bbApiError.message
				})
			}
		})
	}

	checkForMoreThanOnePlateType(scans: any): boolean {
		const plateTypes = scans.filter(scan => scan.scanType === "PLATE")
		return plateTypes.length > 1;
	}

	getPlateScanForNextPopUp(actionMap: any, actionList: any, index: any, openDialogDTO: any, plateScanValues: Array<Array<string>>, scans: any): Array<Array<string>> {
		const isAction = index < actionList.length;
		const hasPopUp = isAction ? actionMap[actionList[index]].hasPopUp : openDialogDTO.end.hasPopUp;
		const hasMachineScanType = scans[0]?.scanType === PopUpScanType.MACHINE;
		const moreThanOnePlateType = this.checkForMoreThanOnePlateType(scans);

		if (!hasPopUp || hasMachineScanType || moreThanOnePlateType) {
			return [];
		}

		plateScanValues.forEach((innerList, index) => {
			if (innerList.length > 0) {
				plateScanValues[index] = [innerList[innerList.length - 1]];
			}
		});

        if(plateScanValues.length === 0){
            this.resetBatchRelatedInfo();
        }

		return plateScanValues;
	}

	private checkForPopUp(actionMap: any, actionList: any, index: any, openDialogDTO: any) {
        if(openDialogDTO.scans.length > 1 || (openDialogDTO.scans.length === 1 && this.openDialogDTO.scans.length > 1)){
            openDialogDTO.plateScanValue = [];
            openDialogDTO.plateSourcePlateIDValues = [];
            this.clearAllPopUpValues();
            this.resetBatchRelatedInfo();
        }
		if ((index < actionList.length && actionMap[actionList[index]].hasPopUp) || (index === actionList.length && openDialogDTO.end.hasPopUp)) {
			this.openDialogDTO = openDialogDTO;
			this.setUpComponentForUpdates();
			this.plateScanValues = openDialogDTO.plateScanValue;
			this.plateSourcePlateIDValues = openDialogDTO.plateSourcePlateIDValues;
		}else{
			this.closeDialogEmitter.emit(true);
		}
	}

	prepareDataForGenericMultiPlateUpdate(): GenericMultiPlateUpdateDTO {
		const dto = new GenericMultiPlateUpdateDTO();
		dto.labID = this.selectedLab.lab._id;
		dto.puid = this.puid;
		dto.processStepName = this.popUpProtocolComponentName;
		dto.updateType = this.popUpUpdateType;
		this.prepareActionAndStatus(dto);

		dto.machinePresentInScan = (PopUpScanType.MACHINE === this.popUpComponent.scans[0].scanType)

		this.prepareDataForTriggerNextAction(dto);

		const plateScanDTOArray: Array<PlateScanDTO> = [];
		const plateScanTypes: Array<string> = [];

		this.plateScanValues.forEach((scan, index) => {
			const plateScanDTO: PlateScanDTO = new PlateScanDTO();
			this.popUpComponent.scans.forEach((scanType, index) => {
				if (PopUpScanType.MACHINE === scanType.scanType) {
					plateScanDTO.machine = scan[index];
					if (!plateScanTypes.includes(scanType.scanName)) {
						plateScanTypes.push(scanType.scanName);
					}
				} else {
					const field = scanType.plateType.toLowerCase() as keyof PlateScanDTO;
					plateScanDTO[field] = scan[index];
					if (!plateScanTypes.includes(scanType.plateType)) {
						plateScanTypes.push(scanType.plateType);
					}
				}
			});
			plateScanDTO.source = this.plateSourcePlateIDValues[index];
            if(this.popUpComponent.scans[0].scanType === PopUpScanType.MACHINE){
                plateScanDTO.batchID = this.plateBatchMap.get(scan[1]);
            }
            else{
                plateScanDTO.batchID = this.plateBatchMap.get(scan[0]);
            }
			plateScanDTOArray.push(plateScanDTO)
		})

		dto.plateScanDTO = plateScanDTOArray;
		dto.plateScanTypes = plateScanTypes;

		if(this.popUpComponent.plateBatching && this.batchView){
			const newBatchInfo: CreateBatchDTO = new CreateBatchDTO();
            if(this.selectedBatch?.id){
                newBatchInfo.id = this.selectedBatch.id;
                newBatchInfo.version = this.selectedBatch.version;
            }
			const sampleType = new Set<string>();
			const plates = new Set<string>();
			this.batchPlates.forEach(plate => {
                const plateDueDate = new Date(plate.dueDate);
				newBatchInfo.priority = Math.min(newBatchInfo.priority,plate.priority);
				newBatchInfo.dueDate = new Date(Math.min(newBatchInfo.dueDate.getTime(),plateDueDate.getTime()));
				sampleType.add(plate.sampleType);
				plates.add(plate.lastUpdatedPlateID);
			});
			newBatchInfo.plates = [...plates];
			newBatchInfo.sampleType  = [...sampleType].join(",");
			newBatchInfo.batchID = this.batchID;
			newBatchInfo.labID = this.selectedLab.lab._id;
			newBatchInfo.type = this.determineBatchType();
			newBatchInfo.projectID = this.selectedProject.projectId;
			newBatchInfo.projectName = this.selectedProject.projectName;
			newBatchInfo.workFlow = this.selectedProjectWorkflow.workflowName;
			newBatchInfo.isBatchCreatedAtAStartStep = this.openDialogDTO.buttonType === ButtonType.START && this.popUpProtocolComponentIndex === 0;
            dto.newBatchInfo = newBatchInfo;
			dto.batching = true;
		}
        dto.batches = [...this.scannedBatches.keys()];
        if(this.popUpComponent.plateUnbatching && this.batchView){
            dto.unbatching = true;
            dto.batches = [this.batchID];
        }
		const widgetEquipmentValues: Map<string, Array<string>> = new Map();
		const widgetChemicalLotValues: Map<string, Array<string>> = new Map();

		this.popUpComponent.widgets.filter(
			widget => this.widgetTypesWithInput.includes(widget.type)
		).forEach(
			widget => {
				const widgetLabel = widget.label as keyof {};
				if (WidgetType.EQUIPMENT === widget.type) {
					widgetEquipmentValues.set(widgetLabel, this.plateWidgetValues.get(widget.id) || new Array<string>());
				} else {
					widgetChemicalLotValues.set(widgetLabel, this.plateWidgetValues.get(widget.id) || new Array<string>());
				}
			}
		)

		dto.widgetChemicalLotValues = Object.fromEntries(widgetChemicalLotValues);
		dto.widgetEquipmentValues = Object.fromEntries(widgetEquipmentValues);
		dto.storagePlateIDs = this.storagePlateIds;

		return dto;
	}

	determineBatchType(): string {
		switch (this.screen) {
			case "EXTRACTION":
				return "EXTRACTION_BATCH";
			case "PLATE_PREPARATION":
				return "PLATE_BATCH";
			case "ARRAY_PREPARATION":
				return "ARRAY_BATCH";
		}
	}

	prepareDataForTriggerNextAction(dto: GenericMultiPlateUpdateDTO) {
		if (this.popUpAction.popUp.triggerNextAction) {
			const actionList = this.openDialogDTO.requiredActions;
			const actionMap = this.selectedProtocol[this.openDialogDTO.stepMapName][this.popUpProtocolComponentName].actionMap;
			this.prepareDataBasedOnActionType(dto, actionList, actionMap);
		}
	}

	prepareDataBasedOnActionType(dto: GenericMultiPlateUpdateDTO, actionList: any, actionMap: any) {
		if (ButtonType.START === dto.updateType) {
			this.prepareDataForStartButton(dto, actionList, actionMap);
		} else if (ButtonType.ACTION === dto.updateType) {
			this.prepareDataForActionButton(dto, actionList, actionMap);
		}
	}

	private prepareDataForStartButton(dto: GenericMultiPlateUpdateDTO, actionList: any, actionMap: any){
		if (actionList.length !== 0 && !actionMap[actionList[0]].hasPopUp) {
			dto.actionName = actionMap[actionList[0]].name;
			dto.actionType = actionMap[actionList[0]].actionType;
			dto.runtime = actionMap[actionList[0]].timerLen;
			dto.triggerNextAction = true;
		} else if (actionList.length === 0 && !this.selectedProtocol[this.openDialogDTO.stepMapName][this.popUpProtocolComponentName].end.hasPopUp) {
			dto.triggerNextAction = true;
			dto.status = this.openDialogDTO.stepListName !== this.ARRAY_STEP_LIST_FIELD_NAME ? StepStatus.plateStepStatusMap.get(`${dto.processStepName}_${ButtonType.END}`) || "" : StepStatus.arrayStepStatusMap.get(`${dto.processStepName}_${ButtonType.END}`) || "";
		}
	}

	private prepareDataForActionButton(dto: GenericMultiPlateUpdateDTO, actionList: any, actionMap: any){
		const index = actionList.indexOf(this.popUpAction.name) + 1;
		if (index < actionList.length && !actionMap[actionList[index]].hasPopUp) {
			dto.nextActionName = actionMap[actionList[index]].name;
			dto.nextActionType = actionMap[actionList[index]].actionType;
			dto.nextRuntime = actionMap[actionList[index]].timerLen;
			dto.triggerNextAction = true;
		} else if (index === actionList.length && !this.selectedProtocol[this.openDialogDTO.stepMapName][this.popUpProtocolComponentName].end.hasPopUp) {
			dto.triggerNextAction = true;
			dto.status = this.openDialogDTO.stepListName !== this.ARRAY_STEP_LIST_FIELD_NAME ? StepStatus.plateStepStatusMap.get(`${dto.processStepName}_${ButtonType.END}`) || "" : StepStatus.arrayStepStatusMap.get(`${dto.processStepName}_${ButtonType.END}`) || "";
		}
	}

	private prepareActionAndStatus(dto: GenericMultiPlateUpdateDTO) {
		if (ButtonType.ACTION === dto.updateType) {
			dto.actionName = this.popUpAction.name;
			dto.actionType = this.popUpAction.actionType;
			dto.runtime = this.popUpAction.timerLen;
		}
		else if (((dto.processStepName === ProtocolComponentName.AMPLIFY_WGA && this.selectedProtocol[this.openDialogDTO.stepListName].includes(ProtocolComponentName.AMPLIFY_PGX)) || dto.processStepName === ProtocolComponentName.AMPLIFY_PGX) && dto.updateType === ButtonType.START) {
			dto.status = StepStatus.plateStepStatusMap.get(`${ProtocolComponentName.AMPLIFY_PGX}_${dto.updateType}`) || "";
			dto.startwgapgx = true;
		} else if ((dto.processStepName === ProtocolComponentName.AMPLIFY_WGA || dto.processStepName === ProtocolComponentName.AMPLIFY_PGX) && dto.updateType === ButtonType.END) {
			this.prepareStatusForEndWGAPGX(dto);
		} else {
			this.setStatusForNormalStep(dto);
		}
	}

	private setStatusForNormalStep(dto: GenericMultiPlateUpdateDTO) {
		if (this.openDialogDTO.stepListName === this.ARRAY_STEP_LIST_FIELD_NAME && dto.updateType === ButtonType.END && this.isFinalStepInProtocol(dto)) {
			dto.status = ArrayStatus.DELIVERED;
		} else {
			dto.status = this.openDialogDTO.stepListName !== this.ARRAY_STEP_LIST_FIELD_NAME ? StepStatus.plateStepStatusMap.get(`${dto.processStepName}_${dto.updateType}`) || "" : StepStatus.arrayStepStatusMap.get(`${dto.processStepName}_${dto.updateType}`) || "";
		}
	}

	private isFinalStepInProtocol(dto: GenericMultiPlateUpdateDTO) {
		return dto.processStepName === this.selectedProtocol.protocolArrayStepList[this.selectedProtocol.protocolArrayStepList.length - 1];
	}

	// Will fail in case of multiple plates update
	private prepareStatusForEndWGAPGX(dto: GenericMultiPlateUpdateDTO) {
		if (dto.processStepName === ProtocolComponentName.AMPLIFY_WGA && this.selectedPlateProcessStepMap.get(ProtocolComponentName.AMPLIFY_PGX)?.endPUID?.trim()) {
			dto.status = StepStatus.plateStepStatusMap.get(`${ProtocolComponentName.AMPLIFY_WGA}_${ProtocolComponentName.AMPLIFY_PGX}_${dto.updateType}`);
		} else if (dto.processStepName === ProtocolComponentName.AMPLIFY_PGX && this.selectedPlateProcessStepMap.get(ProtocolComponentName.AMPLIFY_WGA)?.endPUID?.trim()) {
			dto.status = StepStatus.plateStepStatusMap.get(`${ProtocolComponentName.AMPLIFY_WGA}_${ProtocolComponentName.AMPLIFY_PGX}_${dto.updateType}`);
		} else {
			dto.status = this.openDialogDTO.stepListName !== this.ARRAY_STEP_LIST_FIELD_NAME ? StepStatus.plateStepStatusMap.get(`${dto.processStepName}_${dto.updateType}`) || "" : StepStatus.arrayStepStatusMap.get(`${dto.processStepName}_${dto.updateType}`) || "";
		}
	}

	validateScan(scanIndex: number, scanType: string, enteredValue: string, label: string, plateType: string){
		this.disableScanInput = true;
		setTimeout(() => {
			try {
				this.validateAndAddPlateForMultiUpdate(scanIndex, scanType, enteredValue, label, plateType);
			} catch (error) {
				this.popUpScanInputValues[scanIndex] = "";
				throw error;
			} finally {
				this.disableScanInput = false;
			}
		});
	}

	validateAndAddPlateForMultiUpdate(scanIndex: number, scanType: string, enteredValue: string, label: string, plateType: string) {

		if (scanIndex !== 0 && (!this.popUpScanInputValues[scanIndex - 1] || this.popUpScanInputValues[scanIndex - 1] === "")) {
			this.messagesService.addWarningMessage({
				severity: 'warn', summary: this.FIELD_EMPTY,
				detail: "Please give some value in the previous field."
			})
			this.findAndHighlightElement(`popUpDialog-scan-${scanIndex - 1}`)
			this.popUpScanInputValues[scanIndex - 1] = "";
			return;
		}
		enteredValue = enteredValue.trim();
		if (enteredValue === "") {
			this.messagesService.addWarningMessage({
				severity: 'warn', summary: this.FIELD_EMPTY,
				detail: "Please give some value in the field."
			})
			this.popUpScanInputValues[scanIndex] = "";
			return;
		}

		if (plateType === PlateScanType.WGA && !enteredValue.endsWith("-WGA")) {
			this.messagesService.addWarningMessage({
				severity: 'warn', summary: "Wrong Suffix",
				detail: "Please scan a WGA plate that ends with -WGA"
			})
			this.popUpScanInputValues[scanIndex] = "";
			return;
		}

		if (plateType === PlateScanType.PGX && !enteredValue.endsWith("-PGX")) {
			this.messagesService.addWarningMessage({
				severity: 'warn', summary: "Wrong Suffix",
				detail: "Please scan a PGX plate that ends with -PGX"
			})
			this.popUpScanInputValues[scanIndex] = "";
			return;
		}

		if (PopUpScanType.MACHINE === scanType) {
			if (this.validateMachineBarcode(enteredValue, label)) {
				this.highlightNextScanInPopUpDialog(scanIndex);
			} else {
				this.popUpScanInputValues[scanIndex] = "";
			}
		} else {
			this.validatePlateBarcode(scanIndex, plateType, enteredValue);
		}
	}

	validateMachineBarcode(barcode: string, machineType: string) {
		if (!this.machineBarcodeMap.has(barcode)) {
			this.messagesService.addWarningMessage({
				severity: 'warn', summary: 'No machine found!',
				detail: `Machine with barcode '${barcode}' does not exist`
			})
			return false;
		}

		const machine = this.machineBarcodeMap.get(barcode) || new Machine();
		const machineTypes = machineType.split(';');
		if (!machineTypes.includes(machine.type.name)) {
			this.messagesService.addWarningMessage({
				severity: 'warn', summary: 'Machine type mismatch!',
				detail: `Machine with barcode ${barcode} is of type ${machine.type.name}. Required machine type ${machineType}`
			})
			return false;
		}

		return true
	}

	showWarningMessageAndClearField(scanIndex: number, summary: string, detail: string) {
		this.messagesService.addWarningMessage({
			severity: "warn", summary: summary, detail: detail
		})
		this.popUpScanInputValues[scanIndex] = "";
	}

	validatePlateBarcode(scanIndex: number, plateType: string, plateBarcode: string) {
		/*
			Removing the duplication check in the popUpScanInputValues array
			as same plate can be used in the further step without actually
			transferring it onto a new plate.
			Also moving the condition to check if the plate is already scanned into
			checkIfPlateIdIsEligibleAndAvailable method as it would always get the new
			plate-id scan value to validate.
		*/

		for (const plateScanValue of this.plateScanValues) {
			for (const value of plateScanValue) {
				if (value === plateBarcode) {
					this.showWarningMessageAndClearField(scanIndex, this.PLATE_NOT_AVAILABLE, `Plate ID ${plateBarcode} is already scanned. Please scan a different barcode.`);
					return;
				}
			}
		}

		this.checkIfPlateIdIsEligibleAndAvailable(scanIndex, plateType, plateBarcode);
	}

	private checkIfPlateIdIsEligibleAndAvailable(scanIndex: number, plateType: string, plateBarcode: string) {
		if ((this.popUpComponent.scans[0].scanType === PopUpScanType.MACHINE && scanIndex === 1) || scanIndex === 0 || this.popUpAction.name === "Start Recombine") {
			this.fetchAndCheckIfPlateIsEligible(scanIndex, plateType, plateBarcode);
		} else if (this.popUpAction.name !== "Start Recombine") {
			this.checkIfPlateIdIsAvailable(scanIndex, plateBarcode, plateType);
		} else {
			this.highlightNextScanInPopUpDialog(scanIndex);
		}
	}

	checkIfPlateIdIsAvailable(scanIndex: number, plateBarcode: string, plateType: string) {
		// Allowing same plate barcode to be used as a different plate type.
		if (this.popUpScanInputValues.some((barcode, idx) => idx !== scanIndex && barcode === plateBarcode)) {
			this.highlightNextScanInPopUpDialog(scanIndex);
			return;
		}

		this.blocked = true;
		this.plateProcessingService.checkDuplicatePlateId(this.selectedLab.lab._id, plateBarcode, plateType).subscribe({
			next: (result) => {
				this.blocked = false;
				if (result.data.duplicate) {
					this.showWarningMessageAndClearField(scanIndex, this.PLATE_NOT_AVAILABLE, `Plate ID ${plateBarcode} is already used. Please scan a different barcode.`);
				} else {
					this.highlightNextScanInPopUpDialog(scanIndex);
				}
			},
			error: (error) => {
				this.blocked = false;
				this.messagesService.addErrorMessage({
					severity: "error", summary: "Error while checking for plate id availability!",
					detail: error.error.bbApiError.message
				})
			}
		})
	}

	prepareMapOfPlateProcessSteps(plate: Plate): Map<string, ProcessStep> {
		const plateStepsMap: Map<string, ProcessStep> = new Map();
		if (!plate.processSteps || plate.processSteps === null) {
			return plateStepsMap;
		}

		plate.processSteps.forEach(step => {
			step.actionMap = new Map();
			step.action.forEach(s => {
				step.actionMap.set(s.action, s);
			})
			plateStepsMap.set(step.step, step);
		});

		return plateStepsMap;
	}

	validateProtocol(fetchedPlate: Plate){
		if (!this.selectedProject.projectId) {
			this.selectedProject = this.projectMap.get(fetchedPlate.projectID) || new Project();
		}
		if (!this.selectedProjectWorkflow) {
			this.selectedProjectWorkflow = this.workflowMap.get(`${fetchedPlate.projectID}_${fetchedPlate.workFlow}`) || new ProjectWorkflow();
		}
		const currentProjectWorkflow = this.workflowMap.get(`${fetchedPlate.projectID}_${fetchedPlate.workFlow}`) || new ProjectWorkflow();
		const fetchedPlateProtocol = this.selectedProtocol.protocolType === ProtocolType.EXTRACTION ? currentProjectWorkflow.upstream[0] : currentProjectWorkflow.downstream[0];

		if ((this.selectedProtocol.protocolName !== fetchedPlateProtocol.protocolName) || (this.selectedProtocol.protocolVersion !== fetchedPlateProtocol.protocolVersion)){
			this.messagesService.addWarningMessage({
				severity: 'warn', summary: PLATE_NOT_ELIGIBLE,
				detail: `Plate protocol '${fetchedPlateProtocol.protocolName}(v${fetchedPlateProtocol.protocolVersion})' does not match the current selected workflow '${this.selectedProtocol.protocolName}(v${this.selectedProtocol.protocolVersion})'`
			})
			return false;
		}

		return true;
	}

	isMultipleScansActiveForBatch(): boolean {
		const { scans } = this.popUpComponent;
		const isMachineScan = scans[0].scanType === PopUpScanType.MACHINE;
		return (scans.length === 2 && !isMachineScan) || (scans.length > 2 && isMachineScan);
	}

    createBatchAsPlateModel(batch:Batch): Plate {
        const plate = new Plate();
        plate.plateID = batch.batchID;
        plate.lastUpdatedPlateID = plate.plateID;
        plate.workFlow = batch.workFlow;
        plate.projectID = batch.projectID;
        plate.status = batch.status;
        plate.processSteps = batch.processSteps;
        plate.type = batch.type;
        return plate;
    }

	extractFirstPlateFromBatch(batch:Batch): Plate {
		const plate = new Plate();
		plate.batchID = batch.batchID;
		plate.projectID = batch.projectID;
		plate.workFlow = batch.workFlow;
		plate.lastUpdatedPlateID = batch.plates[0];
		plate.processSteps = batch.processSteps;
        plate.status = batch.status;
		return plate;
	}

	fetchAndCheckIfPlateIsEligible(scanIndex: number, plateType: string, plateBarcode: string) {
		this.blocked = true;
		this.plateProcessingService.getBatch(this.selectedLab.lab._id, plateBarcode).subscribe({
			next: (batch) => {
				this.blocked = false;
				if (!batch) {
					//If the id is not a batch, proceed with the normal flow.
					this.fetchPlate(scanIndex,plateType,plateBarcode);
				} else {
					// We still need the source plate id for the multi update to work.
					// Therefore, create a plate model with the lastUpdatedPlateID as the first plate of the batch
					// and call the pushBatchInfo to fetch all the plates info related to that batch.
					this.processBatch(batch,scanIndex);
				}
			},
			error: (_error) => {
				this.blocked = false;
				this.messagesService.addErrorMessage({
					severity: 'error', summary: 'Error occurred while checking for batch',
					detail: `Something went while determining if the id ${plateBarcode} is a batch or not. Please contact BB Support`
				});
			}
		});
	}

	processBatch(batch:Batch,scanIndex:number): void {
		this.validateForProcessing(null,batch,scanIndex,true,() => {
			const isBatchValidForProcessing = this.validateBatchBasedOnConfiguration(batch);
			if(!isBatchValidForProcessing){
                const plates = batch.plates.length;
                const message = plates !== 0
                    ? `Batch ${batch.batchID} already contains ${plates} plate(s) and cannot be used for batching again. Please empty the batch in order to reuse it.`
                    : `Batch ${batch.batchID} is not valid as it does not have any plates assigned. Please scan a valid batch to proceed.`;
				this.messagesService.addErrorMessage({
					severity:'error',summary:'Invalid batch scanned!',
					detail:message
				});
                this.findAndHighlightElement(`popUpDialog-scan-${scanIndex}`);
				this.popUpScanInputValues[scanIndex] = "";
				return;
			}


			if(this.scannedBatches.has(batch.batchID)){
				this.messagesService.addWarningMessage({
					severity:'warn',summary:'Batch already scanned!',
					detail:`Batch: ${batch.batchID} is already scanned. Please scan a different batch`
				});
                this.findAndHighlightElement(`popUpDialog-scan-${scanIndex}`)
				this.popUpScanInputValues[scanIndex] = "";
				return;
			}
			if(this.isMultipleScansActiveForBatch()){
				this.messagesService.addWarningMessage({
					severity: 'warn',
					summary: 'Batch Scanned!',
					detail: 'You have scanned a batch in a configuration where the ID switch occurs. Please scan individual plates from the batch, as this will override the plates in the batch.'
				});
                this.findAndHighlightElement(`popUpDialog-scan-${scanIndex}`)
				this.popUpScanInputValues[scanIndex] = "";
				return;
			}
			const plate = this.extractFirstPlateFromBatch(batch);
			if(!this.validateProtocol(plate)){
                this.findAndHighlightElement(`popUpDialog-scan-${scanIndex}`)
				this.popUpScanInputValues[scanIndex] = "";
				return;
			}
			const processStepMap = this.prepareMapOfPlateProcessSteps(plate);
			if(this.eligiblePlate(processStepMap)){
				this.pushBatchInfo(plate,false);
			}
		});
	}

	validateForProcessing(plate: Plate, batch: Batch, scanIndex: number, isBatch: boolean, afterProtocolValidation: () => void) {
		const key = isBatch ? `${batch.projectID}_${batch.workFlow}` : `${plate.projectID}_${plate.workFlow}`;
		const plateWorkflow = this.workflowMap.get(key);
		if (!plateWorkflow) {
			this.messagesService.addErrorMessage({
				severity: 'error', summary: 'No workflow found!',
				detail: 'Something went wrong while validating workflow. Please contact BB support'
			});
			this.popUpScanInputValues[scanIndex] = "";
			return;
		}
		if (this.screen === "EXTRACTION") {
			const validationResult = isBatch ? validateBatchEligibility(batch, this.selectedProtocol, null, "EXTRACTION") :
				validateProtocolForPlate(plate, plateWorkflow, this.screen, [], [], []);
			if (!validationResult?.valid) {
				this.messagesService.addErrorMessage(validationResult?.errorMessage);
				this.popUpScanInputValues[scanIndex] = "";
				return;
			}
			afterProtocolValidation();
			return;
		}
		this.validateForProcessingDownstream(plate, batch, isBatch, plateWorkflow, scanIndex, afterProtocolValidation);
	}

	validateForProcessingDownstream(plate:Plate,batch:Batch,isBatch:boolean,plateWorkflow:ProjectWorkflow,scanIndex:number,afterProtocolValidation: () => void){
		const extractionProtocol = plateWorkflow.upstream[0];
		if (!extractionProtocol) {
			const validationResult = isBatch ? validateBatchEligibility(batch,null,this.selectedProtocol,this.screen) : validateProtocolForPlate(plate, plateWorkflow, this.screen, this.selectedProtocol.protocolStepList, [], this.selectedProtocol.protocolArrayStepList);
			if(!validationResult?.valid){
				this.messagesService.addErrorMessage(validationResult?.errorMessage);
				this.popUpScanInputValues[scanIndex] = "";
				return;
			}
			afterProtocolValidation();
			return;
		}
		this.blocked = true;
		this.configurationService.getProtocol(this.selectedLab.lab._id,extractionProtocol.protocolName,extractionProtocol.protocolVersion).subscribe({
			next: (result) => {
				this.blocked = false;
				if (JSON.stringify(result) === "{}") {
					this.messagesService.addErrorMessage({
						severity: "error", summary: "Plate protocol not found",
						detail: `Protocol ${extractionProtocol.protocolVersion}(v${extractionProtocol.protocolVersion}) not found for plate ${plate.lastUpdatedPlateID}`
					});
					this.popUpScanInputValues[scanIndex] = "";
					return;
				}
				const fetchedExtractionProtocol = result.data;
				if (fetchedExtractionProtocol) {
					const validationResult = isBatch ? validateBatchEligibility(batch, fetchedExtractionProtocol, this.selectedProtocol, this.screen) : validateProtocolForPlate(plate, plateWorkflow, this.screen, this.selectedProtocol.protocolStepList, fetchedExtractionProtocol?.protocolExtractionStepList, this.selectedProtocol.protocolArrayStepList);
					if (!validationResult?.valid) {
						this.messagesService.addErrorMessage(validationResult?.errorMessage)
						this.popUpScanInputValues[scanIndex] = "";
						return;
					}
					afterProtocolValidation();
				}
			},
			error: (_error) => {
				this.blocked = false;
				this.popUpScanInputValues[scanIndex] = "";
				this.messagesService.addErrorMessage({
					severity:'error',summary:'Protocol validation failed!',
					detail:'Something went wrong while validating protocol. Please contact BB support'
				});
			}
		});
	}

	fetchPlate(scanIndex:number,plateType:string,plateBarcode:string) {
		this.blocked = true;
		this.plateProcessingService.getPlateDetailsForMultiUpdate(this.selectedLab.lab._id, plateBarcode, plateType).subscribe({
			next: (result) => {
				this.blocked = false;
				const fetchedPlate: Plate = result.data;
				this.validateForProcessing(fetchedPlate,null,scanIndex,false,() => {
					if(!this.validateProtocol(fetchedPlate)){
						return;
					}

					const fetchedPlateProcessStepsMap: Map<string, ProcessStep> = this.prepareMapOfPlateProcessSteps(fetchedPlate);
					if (this.eligiblePlate(fetchedPlateProcessStepsMap)) {
						this.popUpScanInputSourcePlateID = fetchedPlate.plateID;
						if(this.popUpComponent.plateBatching && this.batchView){
                            if(fetchedPlate.batchID){
                                this.messagesService.addErrorMessage({
                                    severity: 'error',summary:'Invalid plate scanned',
                                    detail: `Plate ${fetchedPlate.lastUpdatedPlateID} is already batched and cannot be re-batched again. Batch: ${fetchedPlate.batchID}`
                                });
                                this.popUpScanInputValues[scanIndex] = "";
                                this.findAndHighlightElement(`popUpDialog-scan-${scanIndex}`)
                                return;
                            }
							this.batchPlates.unshift(fetchedPlate);
						}
						this.highlightNextScanInPopUpDialog(scanIndex);
						this.getNextPlateID(scanIndex, fetchedPlate.projectName);
						this.pushBatchInfo(fetchedPlate);
						this.updatedPlatesCache.push(fetchedPlate);
						if(fetchedPlate.storagePlate){
							this.storagePlateIds.push(fetchedPlate.plateID);
						}
					} else {
						this.popUpScanInputValues[scanIndex] = "";
                        this.findAndHighlightElement(`popUpDialog-scan-${scanIndex}`)
					}
					if (this.popUpAction.name === ProtocolComponentMapping.getTitle("ALIQUOTATION","END") && fetchedPlate.samples.length < 96) {
						this.underFilledPlates.add(plateBarcode);
						this.messagesService.addWarningMessage({
							severity: 'warn',
							summary: 'Under filled plate scanned!!!',
							detail: `Plate ${plateBarcode} is an under filled plate.Current under filled plate count: ${this.underFilledPlates.size}`
						});
					}
				})
			},
			error: (_error) => {
				this.blocked = false;
				this.messagesService.addErrorMessage({
					severity: 'error', summary: 'Error while fetching plate details!',
					detail: `No plate found having ${plateType} as ${plateBarcode} in lab ${this.selectedLab.label}`
				});
                this.findAndHighlightElement(`popUpDialog-scan-${scanIndex}`);
				this.popUpScanInputValues[scanIndex] = "";
			}
		})
	}

	getNextPlateID(scanIndex: number, plateProjectName : string) {

		const protocolComponent: ProtocolComponent = this.selectedProtocol[this.openDialogDTO.stepMapName][this.selectedProtocol[this.openDialogDTO.stepListName][this.popUpProtocolComponentIndex]];
		const actionName = this.openDialogDTO.requiredActions[this.popUpActionIndex];

		let regex = "";
		regex = this.getRegexFormat(protocolComponent, actionName);
		if (regex === "" ) {
			if(this.popUpComponent.scans.length !== scanIndex + 1){
				this.messagesService.addWarningMessage({
					severity: 'warn', summary: "No Barcode template configured!",
					detail: "No Regex configured, did not auto generate barcode."
				})
			}
			return;
		}
		let year = "";
		let projectName = "";
		if (regex.includes("2digitYear") || regex.includes("4digitYear") ) {
			year = new Date().getFullYear().toString();
		}

		if (regex.includes("ProjectName")) {
			if(!plateProjectName){
				this.messagesService.addWarningMessage({
					severity: 'warn', summary: "Project Not found!",
					detail: "No project found for plate, did not auto generate barcode."
				})
				return;
			}
			projectName = plateProjectName;
		}
		this.plateProcessingService.createPlateBarcode(this.selectedLab.lab._id, projectName, year, regex).subscribe({
			next: (result) => {
				this.blocked = false;
				if (result.data) {
					let nextHighlightScanIndex = 0;
					const popUpScans = this.popUpComponent.scans;
					if (popUpScans.length === scanIndex + 1) {
						return;
					} else {
						nextHighlightScanIndex = scanIndex + 1
					}
					this.popUpScanInputValues[nextHighlightScanIndex] = result.data;
				}
			},
			error: (_error) => {
				this.blocked = false;
				this.messagesService.addErrorMessage({
					severity: 'error', summary: 'Unable to generate plate barcode!',
					detail: _error
				});
			}
		})
	}

	private getRegexFormat(protocolComponent: ProtocolComponent, actionName: string) {

		switch (this.popUpUpdateType) {
			case ButtonType.START: {
				if (protocolComponent?.start?.popUp?.scans) {
					return protocolComponent.start.popUp.scans[0].regex;
				}
				break;
			}

			case ButtonType.END:{
				if (protocolComponent?.end?.popUp?.scans) {
					return protocolComponent.end.popUp.scans[0].regex;
				}
				break;
			}

			case ButtonType.ACTION:
				{
					if (protocolComponent?.actionMap[actionName]?.popUp?.scans) {
						return protocolComponent.actionMap[actionName].popUp.scans[0].regex;
					}
					break;
				}

			default:
				return "";
		}
	}

	eligiblePlate(processStepsMap: Map<string, ProcessStep>) {
		if ((!processStepsMap || processStepsMap === null)) {
			return false;
		}
		switch (this.popUpUpdateType) {
			case ButtonType.START:
				return this.activeProcessStepStart(this.popUpProtocolComponentName, processStepsMap);
			case ButtonType.END:
				return this.activeProcessStepEnd(this.popUpProtocolComponentName, processStepsMap);
			case ButtonType.ACTION:
				return this.activeProcessStepAction(this.popUpProtocolComponentName, this.popUpActionIndex, processStepsMap);
			default:
				return false;
		}
	}

	isPreviousProcessStepCompleted(stepName: string, selectedPlateStepsMap: Map<string, ProcessStep>, warningButtonType: ButtonType): boolean {
		if (this.popUpProtocolComponentIndex === 0) {
			return true
		}

		const isPreviousStepNotNeeded = this.COMPONENT_WITH_NO_PROCESS_STEPS.has(this.selectedProtocol[this.openDialogDTO.stepListName][this.popUpProtocolComponentIndex - 1])
		if (isPreviousStepNotNeeded && this.popUpProtocolComponentIndex === 1) {
			return true;
		}

		const indexDiff = isPreviousStepNotNeeded ? 2 : 1
		if (!selectedPlateStepsMap.has(this.selectedProtocol[this.openDialogDTO.stepListName][this.popUpProtocolComponentIndex - indexDiff])) {
			this.showNotEligibleWarningMessage(warningButtonType, stepName);
			return false;
		}
		return selectedPlateStepsMap.get(this.selectedProtocol[this.openDialogDTO.stepListName][this.popUpProtocolComponentIndex - indexDiff])?.endTimeStamp !== null;
	}

	activeProcessStepStart(stepName: string, selectedPlateStepsMap: Map<string, ProcessStep>): boolean {
		let active = true;

		active = this.isPreviousProcessStepCompleted(stepName, selectedPlateStepsMap, ButtonType.START)
		if(!active){
			this.showNotEligibleWarningMessage(ButtonType.START, stepName);
			return active;
		}

		if (stepName === ProtocolComponentName.RECOMBINE_DNA) {
			const wga = selectedPlateStepsMap.get(ProtocolComponentName.AMPLIFY_WGA)
			const pgx = selectedPlateStepsMap.get(ProtocolComponentName.AMPLIFY_PGX)
			if (wga?.endPUID?.trim() && pgx?.endPUID?.trim()) {
				active = true;
			} else {
				active = false;
			}
		}

		if (selectedPlateStepsMap.has(stepName)) {
			active = false;
		}

		if (!active) {
			this.showNotEligibleWarningMessage(ButtonType.START, stepName);
		}

		return active;
	}

	activeProcessStepAction(stepName: string, actionIndex: number, selectedPlateStepsMap: Map<string, ProcessStep>): boolean {
		let active = true;

		active = this.isPreviousProcessStepCompleted(stepName, selectedPlateStepsMap, ButtonType.ACTION)
		if(!active){
			this.showNotEligibleWarningMessage(ButtonType.ACTION, stepName);
			return active;
		}

		if (!selectedPlateStepsMap.has(stepName)) {
			this.showNotEligibleWarningMessage(ButtonType.ACTION, stepName);
			return false;
		}

		const protocolComponent: ProtocolComponent = this.selectedProtocol[this.openDialogDTO.stepMapName][this.selectedProtocol[this.openDialogDTO.stepListName][this.popUpProtocolComponentIndex]];
		const actionName = this.openDialogDTO.requiredActions[actionIndex];

		if (selectedPlateStepsMap.get(stepName)?.actionMap.has(actionName)) {
			this.showNotEligibleWarningMessage(ButtonType.ACTION, stepName);
			return false
		}

		if (actionIndex > 0 && !selectedPlateStepsMap.get(stepName)?.actionMap.has(this.openDialogDTO.requiredActions[actionIndex - 1])) {
			this.showNotEligibleWarningMessage(ButtonType.ACTION, stepName);
			return false
		}

		if (!active) {
			this.showNotEligibleWarningMessage(ButtonType.ACTION, stepName);
		}

		return active
	}

	activeProcessStepEnd(stepName: string, selectedPlateStepsMap: Map<string, ProcessStep>): boolean {
		let active = true;

		active = this.isPreviousProcessStepCompleted(stepName, selectedPlateStepsMap, ButtonType.END);
		if(!active){
			this.showNotEligibleWarningMessage(ButtonType.END, stepName);
			return active;
		}

		if (!selectedPlateStepsMap.has(stepName)) {
			this.showNotEligibleWarningMessage(ButtonType.END, stepName);
			return false;
		}

		if (this.checkActionsForCompleteStep(selectedPlateStepsMap, stepName)) {
			this.showNotEligibleWarningMessage(ButtonType.END, stepName);
			return false
		}

		if (selectedPlateStepsMap.get(stepName)?.endTimeStamp) {
			this.showNotEligibleWarningMessage(ButtonType.END, stepName);
			return false;
		}

		if (!active) {
			this.showNotEligibleWarningMessage(ButtonType.END, stepName);
		}

		return active
	}

	private checkActionsForCompleteStep(selectedPlateStepsMap: Map<string, ProcessStep>, stepName: string): boolean {
		return this.openDialogDTO.requiredActions.length !== this.countUniqueFileUploadActions(selectedPlateStepsMap.get(stepName)?.action);
	}

	countUniqueFileUploadActions(actionList: Action[]): number {
		return new Set(actionList.map(action => action.action)).size;
	}

	showNotEligibleWarningMessage(updateType: string, stepName: string) {
		let errorDetail = `Plate is not eligible for ${stepName} - ${updateType}`;
		if (this.popUpActionIndex !== -1) {
			errorDetail += ` ${this.popUpAction.name}`
		}

		this.messagesService.addWarningMessage({
			severity: 'warn', summary: PLATE_NOT_ELIGIBLE,
			detail: errorDetail
		})
	}

	highlightNextScanInPopUpDialog(scanIndex: number) {
		const popUpScans = this.popUpComponent.scans;
		let nextHighlightScanIndex = 0;
		if (popUpScans.length === scanIndex + 1) {
			// Add plates to the list
			this.plateScanValues.unshift(Array.from(this.popUpScanInputValues))
			this.plateSourcePlateIDValues.unshift(this.popUpScanInputSourcePlateID);
			this.clearPopUpScanInputValues(popUpScans[0].sticky);

			nextHighlightScanIndex = popUpScans[0].sticky ? 1 : 0;
		} else {
			nextHighlightScanIndex = scanIndex + 1
		}
		this.popUpScanInputValues[nextHighlightScanIndex] = "";
		this.findAndHighlightElement(`popUpDialog-scan-${nextHighlightScanIndex}`)
	}

	clearPopUpScanInputValues(keepFirstValue: boolean) {
		this.popUpScanInputValues = this.popUpScanInputValues.map((value, index) => {
			return (index === 0 && keepFirstValue) ? value : ""
		})
		this.popUpScanInputSourcePlateID = "";
	}

    deleteScanValues(index: number) {
        const plateScan = this.plateScanValues[index];
        const plateID = this.popUpComponent.scans[0].scanType === PopUpScanType.MACHINE ? plateScan[1] : plateScan[0];
        if(this.plateBatchMap.has(plateID)){
            const batchID = this.plateBatchMap.get(plateID);
			this.confirmationService.confirm({
				header: 'Batched plate being removed from processing!',
				message: `You are about to remove the plate: ${plateID}, which is part of the batch: ${this.plateBatchMap.get(plateID)}. Since all plates are required to update the batch, do you want to remove this plate from the batch?`,
				acceptLabel: `Yes,Remove ${plateID} from batch: ${batchID}`,
				rejectLabel: `No, do not remove the plate`,
				icon: 'pi pi-exclamation-triangle',
				accept: () => this.deleteBatchedPlate(index, plateID),
				reject: () => {}
			});
			return;
		}
        this.plateScanValues.splice(index, 1);
        this.plateSourcePlateIDValues.splice(index, 1);
        if (this.popUpComponent.plateBatching && this.batchView) {
            this.batchPlates.splice(index, 1);
        }
		this.updatedPlatesCache = this.updatedPlatesCache.filter(plate => plate.plateID!==plateID);
        if (this.popUpAction.name === ProtocolComponentMapping.getTitle("ALIQUOTATION", "END")) {
            this.underFilledPlates.delete(plateID);
        }
    }

    deleteBatchedPlate(index:number,plateID: string) {
        const batchID = this.plateBatchMap.get(plateID);
        const body: RemoveSelectedPlateFromBatch = {
            labID:this.selectedLab.lab._id,
            batchID:batchID,
            sourcePlateID:this.lastUpdatedPlateMap.get(plateID),
            batchedPlateID:plateID
        };
		this.blocked = true;
        this.plateProcessingService.removeSelectedPlatesFromBatch(body).subscribe({
            next: (message) => {
                this.blocked = false;
                this.plateScanValues.splice(index, 1);
                this.plateSourcePlateIDValues.splice(index, 1);
                if (this.popUpComponent.plateBatching && this.batchView) {
                    this.batchPlates.splice(index, 1);
                }
                const remainingPlates = new Set([...this.scannedBatches.get(batchID)].filter(plate => plate !== plateID));
                if (remainingPlates.size === 0) {
                    this.scannedBatches.delete(batchID);
					this.fetchedBatches.delete(batchID);
                } else {
                    this.scannedBatches.set(batchID, remainingPlates);
					this.fetchedBatches.set(batchID,remainingPlates);
                }
                this.plateBatchMap.delete(plateID);
                this.lastUpdatedPlateMap.delete(plateID);
                this.messagesService.addSuccessMessage({
                    severity:'success',summary:message
                });
            },
            error: (_error) => {
                this.blocked = false;
                this.messagesService.addErrorMessage({
                    severity: 'error', summary: 'Unable to remove selected plate',
                    detail: `Something went wrong while removing ${plateID} from batch: ${batchID}.Please contact BB support.`
                });
            }
        });
    }

	validateAndUpdateEquipmentValue(widgetId: string, machineType: string, widgetIndex: number) {
		const equipmentValue = this.popUpWidgetInputValues[widgetId].trim();
		if (equipmentValue === "") {
			this.plateWidgetValues.get(widgetId)?.pop();
			return;
		}

		const equipmentValid: boolean = this.validateMachineBarcode(equipmentValue, machineType);
		if (!equipmentValid) {
			this.plateWidgetValues.get(widgetId)?.pop();
			this.popUpWidgetInputValues[widgetId] = "";
			return;
		}

		if (!this.plateWidgetValues.get(widgetId)?.includes(equipmentValue)){
			this.plateWidgetValues.get(widgetId)?.push(equipmentValue);
		}

		this.findAndHighlightElement(this.findNextInputWidgetId(widgetIndex))
	}

	findNextInputWidgetId(startIndex: number): string {
		if (this.popUpComponent.widgetCount === startIndex + 1) {
			return "button-id"
		}

		let nextInputWidgetIndex!: number;

		for (let i = startIndex + 1; i < this.popUpComponent.widgetCount; i++) {
			if (this.widgetTypesWithInput.includes(this.popUpComponent.widgets[i].type)) {
				nextInputWidgetIndex = i;
				break;
			}
		}

		return `pop-up-input-${nextInputWidgetIndex}`;
	}

    pushBatchInfo(plate: Plate,skipPlate = true) {
        const batchID = plate?.batchID;
		if(!batchID){
			return;
		}
        const currentScannedPlateID = plate?.lastUpdatedPlateID;
        const scansLength = this.popUpComponent.scans.length;
        const doesScanHaveMachineInput = this.popUpComponent.scans[0].scanType === PopUpScanType.MACHINE;
        this.plateBatchMap.set(currentScannedPlateID,batchID);
        if(this.scannedBatches.has(batchID)){
            const plates = this.scannedBatches.get(batchID);
            plates.add(currentScannedPlateID);
            this.scannedBatches.set(batchID,plates);
            this.autoLoadBatchedPlates(scansLength,doesScanHaveMachineInput,batchID,skipPlate,currentScannedPlateID,plate);
        }
        else {
            this.scannedBatches.set(batchID, new Set([currentScannedPlateID]));
            this.blocked = true;
            this.plateProcessingService.getPlatesBasedOnBatch(this.selectedLab.lab._id, batchID).subscribe({
                next: (plates) => {
                    this.blocked = false;
                    this.fetchedBatches.set(batchID, new Set(plates.map(currentPlate => {
                        this.lastUpdatedPlateMap.set(currentPlate.lastUpdatedPlateID, currentPlate.plateID);
						this.updatedPlatesCache.push(currentPlate);
                        return currentPlate.lastUpdatedPlateID;
                    })));
                    this.autoLoadBatchedPlates(scansLength, doesScanHaveMachineInput, batchID,skipPlate, currentScannedPlateID, plate);
                },
                error: (_error) => {
                    this.blocked = false;
                    this.messagesService.addErrorMessage({
                        severity: 'error', summary: 'Unable to fetch batch related information!',
                        detail: `Plate ${plate.lastUpdatedPlateID} belongs to the batch: ${batchID} which failed to load.Please contact BB support`
                    });
                }
            });
        }

    }

    autoLoadBatchedPlates(scansLength: number, doesScanHaveMachineInput: boolean, batchID: string,skip:boolean, currentScannedPlateID: string, plate: Plate) {
        if (scansLength === 1 || (scansLength === 2 && doesScanHaveMachineInput)) {
            this.loadAllBatchedPlates(batchID, doesScanHaveMachineInput,skip, currentScannedPlateID);
        } else {
            this.validateBatchedPlatesBeingScanned(plate);
        }
    }

    getMachineScannedIfMachineScanIsConfigured(isMachineScanInputPresent: boolean): string | null {
        if (!isMachineScanInputPresent) {
            return null;
        }

        return this.plateScanValues.length > 0 && this.plateScanValues[0][0] === this.popUpScanInputValues[0]
            ? this.plateScanValues[0][0]
            : this.popUpScanInputValues[0] || this.plateScanValues[0][0];
    }



    loadAllBatchedPlates(batchID: string, isMachineScanInputPresent = false,skip:boolean,plateToBeSkipped:string) {
        const batchedPlates = this.fetchedBatches.get(batchID);
        const scanIndex = isMachineScanInputPresent ? 1 : 0;
		const scannedMachine = this.getMachineScannedIfMachineScanIsConfigured(isMachineScanInputPresent);
        batchedPlates.forEach(plate => {
			//During the first scan, The plate would be pushed into the list automatically before
			//batch information is fetched, so we can skip that plate during autoload.
			//This is only when plate is scanned instead of the batch.
            if(skip && plateToBeSkipped === plate){
                return;
            }
			this.popUpScanInputValues = scannedMachine ? [scannedMachine,plate] : [plate];
			this.popUpScanInputSourcePlateID = this.lastUpdatedPlateMap.get(plate);
			this.highlightNextScanInPopUpDialog(scanIndex);
            this.scannedBatches.get(batchID).add(plate);
            this.plateBatchMap.set(plate,batchID);
        });
        this.messagesService.addSuccessMessage({
            severity: 'success', summary: 'Batched Plates scanned!',
            detail: `A batched plates was scanned belonging to the batch: ${batchID}. As a result, all the batched plates are loaded`
        });
    }

    validateBatchedPlatesBeingScanned(plate:Plate) {
        const plates = [...this.fetchedBatches.get(plate?.batchID) ?? []];
        const remainingPlatesLeftToScan = plates.filter(batchedPlate => !this.scannedBatches.get(plate?.batchID).has(batchedPlate));
        if(remainingPlatesLeftToScan.length === 0){
            this.messagesService.addSuccessMessage({
                severity:'success',summary:'All plates scanned',
                detail:`All plates belonging to batch: ${plate.batchID} is scanned.`
            });
        }
        else {
            this.messagesService.addInfoMessage({
                severity:'info',summary:"Batched Plates scanned!",sticky:true,
                detail:`Plate ${plate.lastUpdatedPlateID} belongs to the batch: ${plate?.batchID}. Remaining plates left to be scanned.${remainingPlatesLeftToScan.join(",")}`
            });
        }
    }

    fetchBatchScanned(): number {
        if(this.scannedBatches.size === 0){
            return 0;
        }
        let batches = 0;
        for(const [batchID,plates] of this.scannedBatches){
            const batchedPlates = this.getBatchedPlates(batchID);
            if(!this.areSetEqual(batchedPlates,plates)){
                continue;
            }
            batches++;
        }
        return batches;
    }
}
